import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { RemoveControl } from './RemoveControl'
import { EditControl } from './EditControl'

export const Action = ({ data = {}, editControlProps, removeControlProps }) => {
  const { t } = useTranslation()

  return (
    <div className={'d-flex gap-4 font-size-14 justify-content-end text-nowrap align-items-center'}>
      <EditControl {...editControlProps} data={data} />

      <RemoveControl {...removeControlProps} data={data} />
    </div>
  )
}

Action.propTypes = {
  data: PropTypes.object,
  editControlProps: PropTypes.object,
  removeControlProps: PropTypes.object,
}
